import React from 'react';
import { connect } from 'react-redux';
import { Message } from 'semantic-ui-react';
import { mapStateToProps } from './dispatch';

const MessageJustUseSearch = props => {
    const { isGreetingMessage } = props.callcenterSearch;
    if (isGreetingMessage) {
        return (
            <Message
                info
                icon="smile outline"
                header="Воспользуйтесь поиском!"
                content="Введите телефон и нажмите кнопку поиск"
            />
        );
    }

    return null;
};

export default connect(mapStateToProps)(MessageJustUseSearch);
